const texts = {
  description: 'A coach must always be either in the pool or with a dedicated AC. Pick the AC who takes this coach — '
    + 'removal from the pool is not possible without one.',
};

export default texts;
